import { firebaseAuth, db } from '../firebase'
import axios from 'axios'
import { config } from '../config'

export function userListener() {
    return dispatch => {
        firebaseAuth().onAuthStateChanged(user => {
            if (user) {
                dispatch({type: "LOGIN_STATE_CHANGED", payload: {auth:true, data:user}})
            } else {
                dispatch({type: "LOGIN_STATE_CHANGED", payload: {auth:false, data:null}})
            }
          })
    }
}

export function login(email, pw) {
    return dispatch => {
        dispatch({type: "USER_LOGIN"})
        firebaseAuth().signInWithEmailAndPassword(email, pw).then(data=>{
            dispatch({type: "USER_LOGIN_FULFILLED", payload: data})
        }).catch(error=>{
            dispatch({type: "USER_LOGIN_REJECTED", payload: error})
        })

    }
}

export function signup(email, pw, name, seekingJob, hackaton) {
    return dispatch => {
        dispatch({type: "USER_SIGNUP"})
        firebaseAuth().createUserWithEmailAndPassword(email, pw).then(()=>{
           let user = firebaseAuth().currentUser
            dispatch({type: "USER_SIGNUP_FULFILLED", payload: user})
            axios.get(`${config.backend}/getloc`).then(x=>{
                user.updateProfile({
                    displayName: name,
                    photoURL: `{"seekingJob":"${seekingJob}","hackaton":"${hackaton}","location":${JSON.stringify(x.data)}}`
                })
              }).catch(error=>{
                user.updateProfile({
                    displayName: name,
                    photoURL: `{"seekingJob":"${seekingJob}", "hackaton":"${hackaton}", "location":{"country":"Unknown","city":"Unknown","region":"Unknown"}}`
                })
              })
        }).catch(error=>{
            dispatch({type: "USER_SIGNUP_REJECTED", payload: error})
        })

    }
}

export function invite(email, name) {
    return dispatch => {
        dispatch({type: "USER_INVITE"})            
            axios.get(`${config.backend}/invitation?name=${name}&email=${email}`).then(result => {
                dispatch({type: "USER_INVITE_FULFILLED", payload: result})
              }).catch(error =>{
                dispatch({type: "USER_INVITE_REJECTED", payload: error})
              })
    }
}

export function hackathon(userData) {
    return dispatch => {
        dispatch({type: "USER_HACKATON"})
        let user = firebaseAuth().currentUser
        let photoURL = {...JSON.parse(userData.photoURL), hackaton:'true'}
        
            user.updateProfile({
                photoURL:JSON.stringify(photoURL).toString()
                }).then(() => {
                    axios.get(`${config.backend}/hackaton?email=${userData.email}`).then(x=>{
                        dispatch({type: "USER_HACKATON_FULFILLED"})
                      }).catch(error=>{
                        dispatch({type: "USER_HACKATON_REJECTED"})
                      })
                }).catch((error) => {
                    dispatch({type: "USER_HACKATON_REJECTED"})
                });
    }
}

export function infoQ(userData, response) {
    return dispatch => {
        dispatch({type: "USER_INFOQ"})
        let user = firebaseAuth().currentUser
        let photoURL = {...JSON.parse(userData.photoURL), infoQ:`${response}`}
        
            user.updateProfile({
                photoURL:JSON.stringify(photoURL).toString()
                }).then(() => {
                    dispatch({type: "USER_INFOQ_FULFILLED"})

                }).catch((error) => {
                    dispatch({type: "USER_INFOQ_REJECTED", payload: error})
                });
    }
}

export function recover(email) {
    return dispatch => {
        dispatch({type: "USER_RECOVER"})
        firebaseAuth().sendPasswordResetEmail(email).then(data=>{
            dispatch({type: "USER_RECOVER_FULFILLED", payload: data})
        }).catch(error=>{
            dispatch({type: "USER_RECOVER_REJECTED", payload: error})
        })

    }
}

export function logout() {
    return dispatch => {
        firebaseAuth().signOut().then(()=>{
            dispatch({type: "USER_LOGOUT_FULFILLED", payload: 'success'})
        }).catch(error=>{
            dispatch({type: "USER_LOGIN_REJECTED", payload: error})
        })
    }
}




// WEBPACK FOOTER //
// ./src/actions/userActions.js